<div class="result animated fadeIn">
  <h2 class="h-main">{{ 'simulation_result_title' | translate }}</h2>
  <div class="row d-flex" [class.loading]="!simulateResult.mortgageResult">
    <div class="col-xl-6 col-lg-12 col-12 d-flex">
      <div class="info-box grey-box w-100">
        <div class="row">
          <div class="col-12 text-align-left">
            <h3 class="h-main h-main-medium">
              {{ 'simulation_result_your_mortgage' | translate }}
            </h3>
          </div>
          <div class="col-6 text-align-left">
            <h4 class="h-main h-main-medium light nowrap">
              {{ 'simulation_result_mortgage_amount' | translate }}
            </h4>
          </div>
          <div class="col-6 text-align-right">
            <h4 class="h-main h-main-medium light nowrap">
              {{ simulateResult?.formValues?.mortgageAmount | number: '1.0-0' }}
              €
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-6 text-align-left">
            <span>
              {{ 'simulation_result_financing_percentage' | translate }}
            </span>
          </div>
          <div class="col-6 text-align-right">
            <span class="nowrap">
              {{ simulateResult?.mortgageResult?.calculation?.ltv * 100 | number: '1.2-2' }}
              %</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-6 text-align-left">
            <span>{{ 'simulation_result_duration_in_years' | translate }}</span>
          </div>
          <div class="col-6 text-align-right">
            <span class="nowrap">
              {{ simulateResult?.formValues?.termInYears }}
              {{ 'label_years_mortgage_product_postpone' | translate }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4 col-lg-8 col-12 d-flex">
      <div class="info-box grey-box w-100">
        <div class="row">
          <div class="col-12 text-align-left">
            <h3 class="h-main h-main-medium">
              {{ 'simulation_result_your_fees' | translate }}
            </h3>
          </div>

          @if (simulateResult?.mortgageResult?.params?.numMonthsFixed !== '0') {
            <ng-container>
              <div class="col-9 text-align-left">
                <span>
                  {{
                    'simulation_result_monthly_fee_n_months'
                      | translate
                        : {
                            months: simulateResult?.mortgageResult?.params?.numMonthsFixed
                              ? simulateResult?.mortgageResult?.params?.numMonthsFixed
                              : '-',
                          }
                  }}
                </span>
              </div>
              <div class="col-3 text-align-right no-pd-l">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.calculation?.monthlyFeeY1 | number: '1.2-2' }}
                  €</span
                >
              </div>
            </ng-container>
          }
        </div>
        <div class="row">
          <div class="col-9 text-align-left">
            <span>
              {{
                (simulateResult?.mortgageResult?.params?.numMonthsFixed === '0'
                  ? 'simulation_result_monthly_fee_other_years_fee_0_months'
                  : 'simulation_result_monthly_fee_other_years'
                )
                  | translate
                    : {
                        years: simulateResult?.formValues?.termInYears,
                      }
              }}
            </span>
          </div>
          <div class="col-3 text-align-right no-pd-l">
            <span class="nowrap"
              >{{ simulateResult?.mortgageResult?.calculation?.monthlyFee | number: '1.2-2' }} €</span
            >
          </div>
        </div>
        <div
          class="row"
          [class.result-susscess]="
            simulateResult?.mortgageResult?.calculation?.dti &&
            simulateResult?.mortgageResult?.calculation?.dti <= RESULT.SUSSCESS
          "
          [class.result-warning]="
            simulateResult?.mortgageResult?.calculation?.dti > RESULT.SUSSCESS &&
            simulateResult?.mortgageResult?.calculation?.dti <= RESULT.DANGER
          "
          [class.result-danger]="simulateResult?.mortgageResult?.calculation?.dti > RESULT.DANGER"
        >
          <div class="col-8 text-align-left">
            <span>
              {{ 'simulation_result_economic_effort_percentage' | translate }}
            </span>
            <a
              id="simulation-result-modal-dti"
              class="icon-a"
              (click)="openModal('dtiDanger')"
              href="javascript:void(0)"
            >
              <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
            </a>
          </div>
          <div class="col-4 text-align-right no-pd-l effort-number">
            <span class="nowrap">
              {{ simulateResult?.mortgageResult?.calculation?.dti * 100 | number: '1.2-2' }}
              %
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-12 no-pd-l d-flex">
      <div class="info-box grey-box info-box__table w-100">
        <div class="row">
          <div class="col-12 text-align-left">
            <h3 class="h-main h-main-medium w-icon">
              {{ 'simulation_result_your_interest' | translate }}
              <a class="icon-a" href="javascript:void(0)" (click)="openModal('interes')">
                <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
              </a>
            </h3>
          </div>

          @if (simulateResult?.mortgageResult?.params?.numMonthsFixed !== '0') {
            <ng-container>
              <div class="col-7 text-align-left h-100 pb-1">
                <span>
                  {{
                    'simulation_result_tin_n_months'
                      | translate
                        : {
                            months: simulateResult?.mortgageResult?.params?.numMonthsFixed
                              ? simulateResult?.mortgageResult?.params?.numMonthsFixed
                              : '-',
                          }
                  }}
                </span>
              </div>
              <div class="col-5 text-align-right">
                <span class="nowrap"
                  >{{ simulateResult?.mortgageResult?.calculation?.tinY1 | number: '1.2-2' : 'es' }} %</span
                >
              </div>
            </ng-container>
          }
        </div>
        <div class="row">
          <div class="col-7 text-align-left">
            <span class="nowrap">
              {{ 'simulation_result_euribor_plus' | translate }}
            </span>
          </div>
          <div class="col-5 text-align-right">
            <span class="nowrap">
              {{ simulateResult?.mortgageResult?.calculation?.differential | number: '1.2-2' : 'es' }}
              %</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-7 text-align-left">
            <span class="nowrap">
              {{ 'simulation_result_tae' | translate }}
            </span>
          </div>
          <div class="col-5 text-align-right">
            <span class="nowrap"
              >{{ simulateResult?.mortgageResult?.calculation?.tae | number: '1.2-2' : 'es' }} %</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- gráfica -->
    <div class="col-lg-6 col-12">
      <div class="graph-bar-section hide-xs">
        <div class="row">
          <div class="col-6">
            <div class="graph-bar">
              <div class="bar bar-amount" [style.height.%]="calculateHeight()?.propertyPrice">
                <div class="bar-info">
                  <h3>{{ 'simulation_result_housing_price' | translate }}</h3>
                  <p>
                    {{ convertNum(this.simulateResult?.formValues?.propertyPrice) | number: '1.2-2' : 'es' }}
                    €
                  </p>
                </div>
              </div>
              <div class="bar bar-savings" [style.height.%]="calculateHeight()?.savingsMade">
                <div class="bar-info">
                  <h3>
                    {{ 'simulation_result_contributed' | translate }}
                    <span>
                      {{ convertNum(this.simulateResult?.formValues?.savingsMade) | number: '1.2-2' : 'es' }}
                      €</span
                    >
                  </h3>
                </div>
              </div>
              <div class="bar bar-cost d-flex" [style.height.%]="calculateHeight()?.tradingTotal">
                <div class="bar-info">
                  <h3>
                    {{ 'simulation_result_housing_purchase_expenses' | translate }}
                  </h3>
                  <p>
                    {{ this.simulateResult?.mortgageResult?.expenses?.trading?.total | number: '1.2-2' : 'es' }}
                    €
                  </p>
                </div>
              </div>
              <div class="bar bar-cost-mortgage" [style.height.%]="calculateHeight()?.mortgageTotal">
                <div class="bar-info">
                  <h3>
                    {{ 'simulation_result_mortgage_expenses' | translate }}
                    <span>
                      {{ this.simulateResult?.mortgageResult?.expenses?.mortgage?.total | number: '1.2-2' : 'es' }}
                      €</span
                    >
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 no-pd">
            <div class="total-bar bar-mortage" [style.height.%]="calculateHeight()?.mortgageAmount">
              <div class="vertical-bar"><span></span></div>
              <div class="bar-info">
                <p class="info-number">
                  {{ convertNum(this.simulateResult?.formValues?.mortgageAmount) | number: '1.2-2' : 'es' }}
                  €
                </p>
                <p>{{ 'simulation_result_money_you_ask' | translate }}</p>
              </div>
            </div>
            <div class="total-bar bar-totalcost" [style.height.%]="100 - calculateHeight()?.mortgageAmount">
              <div class="vertical-bar"><span></span></div>
              <div class="bar-info">
                <p class="info-number">{{ getMoneyContribute() | number: '1.2-2' : 'es' }} €</p>
                <p>
                  {{ 'simulation_result_money_contribute_now' | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="info-box info-box__table costs">
        <div class="row" [class.loading]="!simulateResult.mortgageResult">
          <div class="col-7 text-align-left">
            <h4 class="h-main h-main-medium">
              {{ 'simulation_result_money_contribute_now_2' | translate }}
            </h4>
          </div>
          <div class="col-5 text-align-right">
            <h4 class="h-main h-main-medium text-align-right nowrap">
              {{ getAmountNotFinanced() | number: '1.2-2' }} €
            </h4>
          </div>
          <div class="col-8 text-align-left">
            <span>
              {{ 'simulation_result_amount_not_financed' | translate }}
            </span>
          </div>
          <div class="col-4 text-align-right">
            <span class="nowrap"> {{ simulateResult?.formValues?.savingsMade | number: '1.2-2' }} € </span>
          </div>
        </div>
        <div class="row" [class.loading]="!simulateResult.mortgageResult">
          <div class="col-12">
            <div class="row">
              <div class="col-6 text-align-left">
                <span>
                  {{ 'simulation_result_expenses_buying_housing' | translate }}
                </span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap"
                  >{{ simulateResult?.mortgageResult?.expenses?.trading?.total | number: '1.2-2' }} €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span> {{ 'simulation_result_taxes' | translate }} </span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.expenses?.trading?.taxes | number: '1.2-2' }}
                  €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span> {{ 'simulation_result_notary' | translate }} </span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap"> {{ totalNotaryTrading() | number: '1.2-2' }} € </span>
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span>{{ 'simulation_result_register' | translate }}</span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.expenses?.trading?.register?.cost | number: '1.2-2' }}
                  €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span> {{ 'simulation_result_agency' | translate }} </span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.expenses?.trading?.agency?.cost | number: '1.2-2' }}
                  €</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="row" [class.loading]="!simulateResult.mortgageResult">
          <div class="col-12">
            <div class="row">
              <div class="col-6 text-align-left">
                <span>
                  {{ 'simulation_result_expenses_approx_mortgage' | translate }}
                </span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap"
                  >{{ simulateResult?.mortgageResult?.expenses?.mortgage?.total | number: '1.2-2' }} €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span>{{ 'simulation_result_taxes' | translate }}</span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.expenses?.mortgage?.taxes | number: '1.2-2' }}
                  €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span>{{ 'simulation_result_notary' | translate }}</span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap"> {{ totalNotaryMortgage() | number: '1.2-2' }} €</span>
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span>{{ 'simulation_result_register' | translate }}</span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.expenses?.mortgage?.register?.cost | number: '1.2-2' }}
                  €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span>{{ 'simulation_result_agency' | translate }}</span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.expenses?.mortgage?.agency?.cost | number: '1.2-2' }}
                  €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-6 text-align-left">
                <span> {{ 'simulation_result_appraisal' | translate }} </span>
              </div>
              <div class="col-6 text-align-right">
                <span class="nowrap">
                  {{ simulateResult?.mortgageResult?.expenses?.mortgage?.assessment?.cost | number: '1.2-2' }}
                  €</span
                >
              </div>
            </div>
            <div class="row result-data">
              <div class="col-7 text-align-left">
                <span class="succes-text"
                  >{{ 'simulation_result_expenses_assumes' | translate }}
                  <a
                    id="simulation-result-tooltip-expenses-pibank"
                    class="icon-a"
                    href="javascript:void(0)"
                    tooltipEvent="focus"
                    (click)="openToast('simulation-result-tooltip-expenses-pibank')"
                    [pTooltip]="'simulation_result_expenses_assumes_tooltip' | translate"
                  >
                    <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
                  </a>
                </span>
              </div>
              <div class="col-5 text-align-right effort-number">
                <span class="succes-text nowrap">- {{ getBonus() | number: '1.2-2' }} €</span>
              </div>
            </div>
            <div class="row result-data">
              <div class="col-12 text-align-left">
                <span> {{ 'simulation_not_bonus' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (!simulateResult?.isOK) {
    <div class="row">
      <!--  <div class="col-lg-6 col-12 no-pd">
              <div class="row" *ngIf="simulateResult && !simulateResult.isOK">
                  <div class="col-lg-6 col-12 no-pd">
                      <div class="row">
                          <div class="col-12">
                              <div class="info-box">
                                  <p class="color-red"> Tu porcentaje de endeudamiento supera lo recomendado </p>
                                  <span class=""> {{ 'reasons.RULE_MORTGAGE_INGRESOS_MIN_REASON' | translate }} </span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div> -->

      @if (isAdvanceSimulator) {
        <div class="row padding-top-10">
          <div class="col-6">
            <div class="row">
              <div class="col-12 padding-right-5">
                <div class="info-box">
                  <button (click)="simulateAgain()">
                    {{ 'simulation_result_repeat_simulate' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
